
import axios from "axios";
// @ts-ignore
import * as formValidation from '@elements/form-validation';
// @ts-ignore
import {translate} from "@elements/translations";

export async function fetcher(url:URL|string) {
    // if url is an url object than use url.href instead
    // is needed, otherwise a javascript error will be thrown from the symfony toolbar
    if (typeof url === 'object') {
        url = url.href;
    }

    return await axios({
        method: 'GET',
        url: url,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json'
        }}).then((res) => res.data)
}

export function deepCopy(obj: any) {
    return JSON.parse(JSON.stringify(obj));
}

export function reassignFormValidationField(form: HTMLFormElement, fieldName: string) {
    formValidation.getApi(form).then((formApi: any) => {
        let formInstance = formApi.getFormInstance();
        formInstance.removeField(fieldName);
        formInstance.addField(fieldName);
    });
}

export function getPersonName(firstName: string, lastName: string) {
    if (firstName === '' && lastName === '') {
        return translate('intersport.unknown-person');
    }

    return `${firstName} ${lastName}`;
}

export function prepareRequestUrl(url) {
    return url + (url.includes('?') ? '&' : '?');
}